import React, { useCallback } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import { userCartItemUndo } from 'actions/UserCartActions'
import styled from 'styled-components'
import TextButton from 'LuxKit/Button/TextButton'
import LineHistoryIcon from 'LuxKit/Icons/line/LineHistoryIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import * as Analytics from 'analytics/analytics'
import { asArray } from 'lib/array/arrayUtils'

const DeletedTileContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: ${rem(12)};
  padding: ${rem(20)};
  border-radius: ${props => props.theme.borderRadius.S};
  background: ${props => props.theme.palette.neutral.default.seven};

  ${mediaQueryUp.tablet} {
    border: 1px solid ${props => props.theme.palette.neutral.default.five};
  }
`

interface Props {
  title: string
  itemIds: Array<string> | string
}

function DeletedCartReviewTile({ title, itemIds }: Props) {
  const dispatch = useAppDispatch()

  const handleUndo = useCallback(() => {
    Analytics.trackClientEvent({
      subject: 'undo_delete_item',
      action: 'click',
      category: 'multi_item_cart',
      type: 'interaction',
    })
    dispatch(userCartItemUndo(asArray(itemIds)))
  }, [dispatch, itemIds])

  return (
    <DeletedTileContainer>
      <Group direction="vertical" gap={4}>
        <BodyText wrap="truncate" variant="medium" weight="bold">{title}</BodyText>
        <BodyText variant="medium" colour="neutral-two">was deleted from your cart</BodyText>
      </Group>
      <TextButton
        kind="secondary"
        size="small"
        shape="round"
        startIcon={<LineHistoryIcon />}
        onClick={handleUndo}
      >
        Undo
      </TextButton>
    </DeletedTileContainer>
  )
}

export default DeletedCartReviewTile
